const getFileType = (url) => {
  let pdfReg = /^.+(\.pdf)$/i;
  let txtReg = /^.+(\.txt)$/i;
  let wordReg = /^.+(\.docIcon|\.docIconx)$/i;
  let excelReg = /^.+(\.xls|\.xlsx)$/i;
  let jpgReg = /^.+(\.png|\.jpg|\.jpeg|\.bmp)$/i;
  if (pdfReg.test(url)) {
    return 'pdf';
  }
  if (txtReg.test(url)) {
    return 'txt';
  }
  if (wordReg.test(url)) {
    return 'word';
  }
  if (excelReg.test(url)) {
    return 'excel';
  }
  if (jpgReg.test(url)) {
    return 'picture';
  }
};

export default getFileType;
